export const risingStarMap: Record<number, { preferred: number; approved: number; others: number }> = {
  1: {
    preferred: 85,
    approved: 70,
    others: 65,
  },
  2: {
    preferred: 85,
    approved: 70,
    others: 65,
  },
  3: {
    preferred: 90,
    approved: 75,
    others: 70,
  },
  4: {
    preferred: 95,
    approved: 80,
    others: 75,
  },
  5: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  6: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  7: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  8: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  9: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  10: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  11: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  12: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
  13: {
    preferred: 100,
    approved: 85,
    others: 80,
  },
} as const;
